// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2IH5s","buttons":"RemoveExpirationActionButtons_buttons__7Iczu"};